import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileDropComponent } from './drop/file-drop.component';
import { UploadFileService } from './upload-file.service';
import { FileDropModule } from 'ngx-file-drop';
import { FileUploadModule } from 'ng2-file-upload';


@NgModule({
  imports: [
    CommonModule,
    FileDropModule,
    FileUploadModule
  ],
  providers: [
    UploadFileService
  ],
  declarations: [
    FileDropComponent,

  ],
  exports: [
    FileDropComponent,
  ]
})
export class UploadFileModule { }



// WEBPACK FOOTER //
// ./client/app/shared/upload-file/upload-file.module.ts